import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hide, show } from '../actions/ActivityIndicatorAction';
import { showMessage } from '../actions/FlashMessageActions';
import Login from '../components/auth/Login';

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showMessage,
      show,
      hide,
    },
    dispatch
  );

const LoginContainer = connect(null, mapDispatchToProps)(Login);

export default LoginContainer;
